import { render, staticRenderFns } from "./Contato.vue?vue&type=template&id=25e7fdf1&scoped=true&"
import script from "./Contato.vue?vue&type=script&lang=js&"
export * from "./Contato.vue?vue&type=script&lang=js&"
import style0 from "./Contato.vue?vue&type=style&index=0&id=25e7fdf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e7fdf1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
